import { useEffect, useRef, useState } from "react";

export default function useInViewOnce(options = {}) {
  const {
    root = null,
    rootMargin = "0px 0px -10% 0px",
    threshold = 0.15,
    once = true,
  } = options;

  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  const [hasEntered, setHasEntered] = useState(false);

  useEffect(() => {
    if (once && hasEntered) return;

    const element = ref.current;
    if (!element) return;

    if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
      setInView(true);
      setHasEntered(true);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;

        const nextInView = Boolean(entry.isIntersecting);
        setInView(nextInView);

        if (nextInView) {
          setHasEntered(true);
          if (once) observer.disconnect();
        }
      },
      { root, rootMargin, threshold }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, [hasEntered, once, root, rootMargin, threshold]);

  return { ref, inView, hasEntered };
}
